import * as React from "react";
import { toast } from "react-toastify";

import type { Organization } from "../../../../application/domain/organization/organization";
import {
  gqlClient,
  gqlHeader,
  runGqlQueryV2,
} from "../../../../graphql/client";

export const FeatureStatus = {
  Available: "AVAILABLE",
  Unavailable: "UNAVAILABLE",
  Loading: "LOADING",
} as const;

export type FeatureStatusValue =
  (typeof FeatureStatus)[keyof typeof FeatureStatus];

type useFeatureAvailabilityType = (
  orgId: string | undefined,
  awaitOrgId?: boolean,
) => { status: FeatureStatusValue; org?: Organization };

export const useFeatureAvailability: useFeatureAvailabilityType = (orgId) => {
  const [status, setStatus] = React.useState<FeatureStatusValue>(
    FeatureStatus.Loading,
  );

  const fetchOrgProducts = async (orgId: string) => {
    const res = await runGqlQueryV2(() =>
      gqlClient.allOrgProductsByOrgId({ orgId }, gqlHeader("q")),
    );
    if (res.error) {
      toast.error("ポータルの製品情報の取得に失敗しました。");
      return;
    }
    const plan = res.data?.allOrgProductsByOrgId.find(
      (v) => v.productCode === "Portal",
    )?.plan;
    if (plan && plan !== "NotSet") {
      setStatus(FeatureStatus.Available);
    } else {
      setStatus(FeatureStatus.Unavailable);
    }
  };

  React.useEffect(() => {
    if (typeof orgId !== "string") {
      setStatus(FeatureStatus.Unavailable);
      return;
    }
    fetchOrgProducts(orgId);
  }, [orgId, setStatus]);

  return {
    status,
  };
};
